import { AbstractAction } from "components/ContextMenuRegistry";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";

const FLIGHT_CONNECTIONS_TAB = "/Flight connections";

export class OpenFlightConnectionsAction extends AbstractAction {

    icon = "plane";
    label = _msg("OpenFlightConnectionsAction.label");

    isVisible(param: IActionParam) {
        return param.selection.length > 0 && this.getEntityName(param.selection[0]) === "Flight";
    }

    async run(param: IActionParamForRun) {
        AppMetaTempGlobals.history.push(entityDescriptors["Flight"].getEntityEditorUrl(this.props.getEntityAt(param.selection[0])?.id) + FLIGHT_CONNECTIONS_TAB);
    }

}